module.exports = __webpack_public_path__ + "static/media/loading-bg-blue.545236f9.gif";